<template>
  <div class="request-access">
    <Card class="request-access__widget">
      <template #header>
        <FontAwesomeIcon :icon="['fad', 'lock']" size="3x" />
      </template>
      <template #default>
        <div class="request-access__content">
          <h1 class="mb-2">{{ $t('requestAccessToAccount') }}</h1>
          <p>{{ $t('requestAccessInformation') }}</p>
          <SelectComponent
            v-model="user"
            items="/api/resource/user?useQueryExtensions=false&type=admin"
            :empty-label="$t('selectx', { x: $tc('user', 1).toLowerCase() }) + '...'"
          />
        </div>
      </template>
      <template #footer>
        <ButtonComponent
          :label="$t('confirm')"
          :icon="['fal', 'angle-right']"
          theme="primary"
          :promise="promise"
          @click="submit"
          :stateTimeout="60000"
        />
      </template>
    </Card>
  </div>
</template>

<script>
import fetch from '@/fetch'
import Card from '@/components/Card'
import { getInstance } from '@/auth'
import { AlertComponent as Alert } from 'vue-elder-alert'
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'

export default {
  metaInfo() {
    return {
      title: this.$t('requestAccessToAccount'),
    }
  },
  data() {
    return {
      user: null,
      promise: null,
    }
  },
  computed: {
    currentUrl() {
      return window.location.host
    },
  },
  methods: {
    async submit() {
      if (!this.$route.query.email) return

      let url = `/api/support/request/${this.$route.query.email}?redirect=${this.$route.query.redirect}`
      if (this.user) url += `&approver=${this.user}`

      this.promise = fetch(url, {
        headers: { authorization: `Bearer ${await getInstance().getTokenSilently()}` },
      })
        .then(res => {
          if (!res.ok) {
            let err = new Error('HTTP status code: ' + res.status)
            err.response = res
            err.status = res.status
            throw err
          }

          if (!res.url.includes('/api/support')) return (location.href = res.url)
        })
        .catch(err => {
          reject(err)
        })
    },
  },

  components: {
    Card,
    Alert,
    SelectComponent,
  },
}
</script>

<style lang="scss">
.request-access {
  background-color: $background-grey;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  &__content {
    text-align: center;
  }

  &__widget {
    flex-grow: 1;
    max-width: 450px;

    h1 {
      font-size: 1.5rem;
    }

    .card__header {
      min-height: unset;
      padding: 4rem;
    }

    .card__footer-content {
      justify-content: center;
    }
  }
}
</style>
